function resizeWindow(){
	if($(document).width() < 1400) {
		$("body").addClass('minify');
	} else {
		$("body").removeClass('minify');
	}
}

function scrollDown(){
	var top = $(document).scrollTop();
	if($('header').length > 0) {
		if (top > 120) {
			$('#content').addClass('header-fix');
		} else {
			$('#content').removeClass('header-fix');
		}
	}
	if($('#langtabs').length > 0) {
		if (top > 120) {
			$('#langtabs').addClass('fix');
		} else {
			$('#langtabs').removeClass('fix');
		}
	}
}

$(document).ready(function () {


	//View Mode
	$('.view-mode').click(function (e) {
		e.preventDefault();
		if($('body').hasClass('light')) {
			$new_mode = 'dark';
			$('body').removeClass('light');
			$('body').addClass('dark');
		} else {
			$new_mode = 'light';
			$('body').removeClass('dark');
			$('body').addClass('light');
		}
		localStorage.setItem("view-mode", $new_mode);
	});	
	if(localStorage.getItem("view-mode") == 'dark') {
		$('body').addClass('dark');
	}
	if(localStorage.getItem("view-mode") == 'light' || localStorage.getItem("view-mode") == '') {
		$('body').addClass('light');
	}
	$('.sidebar__collapse').click(function (e) {
		$(this).toggleClass('active');
		$('body').toggleClass('minify');
		if($('body').hasClass('minify')) {
			$sidebar_mode = 'minify';
			$('.main-nav li').removeClass('open');
		} else {
			$sidebar_mode = 'full';
		}
		localStorage.setItem("sidebar", $sidebar_mode);
	});
	if(localStorage.getItem("sidebar") == 'minify') {
		$('body').addClass('minify');
		$('.sidebar__collapse').toggleClass('active');
		$('.main-nav li').removeClass('open');
	}
	setTimeout(function(){
		$("body").css("opacity",1);
    }, 200);

	//resizeWindow();
	$(window).resize(function(event) {
		//resizeWindow();
	}); 
	$(window).scroll(function (event) {
		scrollDown();
	});

	//clear site cache
	$('.btnClearSiteCache').click(async function() {
		if($("#clearCacheProcess").val() == 0){
			$("#clearCacheProcess").val(1);
			$(".clearCacheLoading").fadeIn(200);
			await $.get(SITE_ROOT + 'ajax/sites_process.php', {
				operation: 'clearSiteCache',
				id: $('input[type="hidden"]#id').val()
			});
			toastr['success']('Site cache was deleted.');
			$("#clearCacheProcess").val(0);
			$(".clearCacheLoading").hide();
		}
	});
   	
   	//Tooltips 
	$('[data-toggle="tooltip"]').tooltip();

	$('.nav-tabs a').click(function (e) {
		e.preventDefault();
		$('.nav-tabs a').removeClass('active');
		$(this).addClass('active');
		var target = $(this).attr('href').replaceAll( ' ',  '-' );
		$('.tab-content .tab-pane').fadeOut(300); 
		$(target).fadeIn(350);
	});
	$('.alert__title').click(function (e) {
		e.preventDefault();
		$(this).siblings().slideToggle();
	});

	//Translation module
	$('#keys .trans__col--unit input').focusin(  
	  	function(){  
	    	var $index = $(this).attr('tabindex');
			$index = parseInt($index)+1;
			$('.divTranslation input[tabindex = '+$index+']').addClass('focus');
		}).focusout(  
	    function(){  
	    	$('.divTranslation input').removeClass('focus');  
	});
	$('.divTranslation .trans__col--unit input').focusin(  
	  	function(){  
	    	var $index = $(this).attr('tabindex');
			$index = parseInt($index)-1;
			$('#keys input[tabindex = '+$index+']').addClass('focus');
		}).focusout(  
	    function(){  
	    	$('#keys input').removeClass('focus');  
	});

	//Sidebar
	$('a.has-sublinks').click(function (e) {
		e.preventDefault();
		if($(this).parent().hasClass('open')) {
			$(".main-nav li").removeClass('open');
		} else {
			$(".main-nav li").removeClass('open');
			$(this).parent().addClass('open');
		}
	});
	$('a.showHistory').click(function (e) {
		e.preventDefault();
		$('#main').fadeToggle();
		$('#history-tab').fadeToggle();
	});
	var tranlation_class_body;
	$('a.showContent').click(function (e) {
		e.preventDefault();

		tranlation_class_body = $(this).html()
		if( !$('body').hasClass( tranlation_class_body ) && !$('.nav.nav-tabs li:first a').hasClass('active') ){
			$('.nav.nav-tabs li:first a').click();
		}	

		$('#main').fadeToggle();
		$('body').toggleClass(tranlation_class_body);
		$($(this).attr("href")).fadeToggle();
			
	});

	// $('.main-nav a.has-sublinks').each(function(i) {
	// 	$target = $(this).parent('li');
	// 	if($target.children('.dropdown ul').length == 0) {
	// 		$($target).hide();
	// 	}
	// });

	$(".fancybox").fancybox({
        'padding':0,
        'scrolling'     :   'auto',
        'nextEffect'    :   'fade',
        'prevEffect'    :   'fade',
        helpers     : {
            title: {
                type: 'inside'
            }
        }
    });

	$(".chosen-select").chosen();

	$(".header li, .top-bar .menu li").hover(function(){
        var target = $(this).find('ul');
        window.mytimeout = setTimeout(function(){
            target.addClass("hover");
            $(target).fadeIn(400);
        }, 200);
    }, function(){
        var target = $(this).find('ul');
        if($(target).hasClass("hover")) {
            $(target).removeClass("hover");
            $(target).fadeOut(400);
        } else {
            clearTimeout(window.mytimeout);
        }
    });
    if($('body').hasClass('minify')) {
    	$(".main-nav li").hover(function(){
	        var target = $(this).find('.dropdown');
	        window.minifytimeout = setTimeout(function(){
	            target.addClass("hover");
	            $(target).fadeIn(400);
	        }, 200);
	    }, function(){
	        var target = $(this).find('.dropdown')
	        if($(target).hasClass("hover")) {
	            $(target).removeClass("hover");
	            $(target).fadeOut(200);
	        } else {
	            clearTimeout(window.minifytimeout);
	        }
	    });
    }
	
	
});
function selectSite(site_id) {
	//alert('SITE CHANGED TO '+site_id);
	$.ajax({
		type: "POST",
		url: SITE_ROOT+"ajax/admin_sites_process.php",
		dataType: "json",
		data:{
			site_id : site_id,
			operation : 'selectSite'
		},
		success: function(data){
			if(typeof data.redirect !== 'undefined') {
				window.location = data.redirect;
			} else if(data.result=='success'){	
				window.location = SITE_ROOT+"index.php";
            }
		}
	});
}